import { Component } from '@angular/core';

@Component({
  selector: 'wpro-no-trusted-device',
  templateUrl: './no-trusted-device.component.html',
  standalone: false
})
export class NoTrustedDeviceComponent {

  constructor() { }

}
